import React, { useEffect, useMemo, useState } from 'react'
import DetailCardComponent from '../../components/Card/Detail/DetailCardComponent'
import { ThemeProvider, Typography } from '@mui/material';
import theme from '../../theme';
import UserNavbarComponent from '../../components/Navbar/UserNavbarComponent';
import UserHomeProductCardComponent from '../../components/Card/UserHomeProductCardComponent';
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import { GetProductAPI } from "../../api/product/ProductController";

const DetailPage = ({ history }) => {
  const location = useLocation();
  const { id } = useParams();
  const { item: itemFromState } = location.state || {};
  const [item, setItem] = useState(itemFromState || null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isLoadingRelated, setIsLoadingRelated] = useState(false);
  const numericId = useMemo(() => {
    if (!id) {
      return null;
    }
    const parsed = Number(id);
    return Number.isNaN(parsed) ? null : parsed;
  }, [id]);

  useEffect(() => {
    if (itemFromState) {
      setItem(itemFromState);
    }
  }, [itemFromState]);

  useEffect(() => {
    if (item || numericId == null) {
      return;
    }
    const postBody = {
      product_Id: numericId,
      Materials: [],
      color: [],
      category: "",
      marketingCategory: "",
      MarketingCategory: "",
      priceRange: "",
    };
    GetProductAPI(
      postBody,
      (products) => {
        if (Array.isArray(products) && products.length > 0) {
          const match = products.find(
            (product) =>
              (product?.productId ?? product?.product_Id) === numericId
          );
          setItem(match || products[0]);
        }
      },
      setIsLoadingRelated,
      true
    );
  }, [item, numericId]);

  useEffect(() => {
    if (!item) {
      setRelatedProducts([]);
      return;
    }

    const category =
      item.category ||
      item.Category ||
      item.categoryName ||
      item.CategoryName ||
      item.productCategory ||
      item.product_Category ||
      "";

    const postBody = {
      product_Id: 0,
      Materials: [],
      color: [],
      category,
      priceRange: "",
    };

    GetProductAPI(postBody, (products) => {
      const currentId = item.productId ?? item.product_Id;
      const filtered = Array.isArray(products)
        ? products.filter(
            (product) =>
              (product.productId ?? product.product_Id) !== currentId
          )
        : [];
      setRelatedProducts(filtered);
    }, setIsLoadingRelated, true);
  }, [item]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <UserNavbarComponent history={history} />

        {item ? (
          <DetailCardComponent item={item} history={history} />
        ) : (
          <Typography
            sx={{
              marginTop: "20px",
              textAlign: "center",
              fontSize: "16px",
              color: theme.palette.grey.main,
            }}
          >
            Loading product...
          </Typography>
        )}
        {!isLoadingRelated && relatedProducts.length > 0 ? (
          <UserHomeProductCardComponent
            title="Related Products"
            data={relatedProducts}
            history={history}
            showViewAll={false}
          />
        ) : !isLoadingRelated ? (
          <Typography
            sx={{
              marginTop: "20px",
              textAlign: "center",
              fontSize: "16px",
              color: theme.palette.grey.main,
            }}
          >
            No related products found.
          </Typography>
        ) : null}
      </ThemeProvider>

    </>
  )
}

export default DetailPage
